<template lang="pug">
  vm-prompt(@vm-cancel="close" vm-size="medium" @vm-accept="close" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-active="isModalTopSuppliersVisible" :vm-title='title')
    .container-fluid
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(max-height="350px" :data="topSuppliers" class="table")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('products.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'purchase_date'")  {{data[indextr]['purchase_order']['created_at'] | moment('DD-MMMM-YYYY')}}
                  slot(v-if="column == 'supplier'")  {{data[indextr]['purchase_order']['supplier']['name']}}
                  slot(v-if="column == 'oc_number'")  {{data[indextr]['purchase_order']['folio']}}
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Products')

export default {
  name: 'ModalProductTopSuppliers',
  props: {
    productId: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    columns: [
      'oc_number',
      'supplier',
      'purchase_date'
    ]
  }),
  computed: {
    ...mapGetters([
      'isModalTopSuppliersVisible',
      'topSuppliers'
    ]),
    title () {
      return this.$t('products.top_suppliers')
    }
  },
  watch: {
    isModalTopSuppliersVisible (flag) {
      if (flag) {
        this.loadTopSuppliers({ id: this.productId })
      }
    }
  },
  methods: {
    ...mapActions([
      'setModalTopSuppliersVisible',
      'loadTopSuppliers'
    ]),
    close () {
      this.setModalTopSuppliersVisible(false)
    }
  }
}
</script>

<style lang="scss">
.row-quantity {
  padding: 30px;
}
.general-information {
  text-align: center;
}
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}

.form__wrapper {
  margin-bottom: 20px;
}

.amount__wrapper {
  padding: 10px 0;
}

.amount {
  font-weight: bold;
  text-align: center;
}

.form-group {
  margin-bottom: 0px !important;
}

.table {
  .td {
    span {
      display: block !important;
      text-align: center !important;
    }
  }
}
</style>
